import Dialog from '@mui/material/Dialog';
import styled from 'styled-components';

import { COLORS } from '../../../theme';
import { ALIGNMENT } from './constants';

export const StyledDialog = styled(Dialog)`
  .MuiBackdrop-root {
    background-color: ${COLORS.blackTransparent};
  }

  .MuiDialog-container {
    align-items: ${({ $align }) => ALIGNMENT[$align] ?? 'start'};
  }

  .MuiDialog-container > .MuiPaper-root {
    width: 100%;
    margin: ${({ theme }) => `${theme.spacing.xl1} ${theme.spacing.m4}`};
    border-radius: ${({ theme }) => theme.borderRadius.primary};
  }

  .MuiDialog-paperWidthXxs {
    max-width: 440px;
  }

  .MuiDialog-paperWidthXs {
    max-width: 552px;
  }

  .MuiDialog-paperWidthSm {
    max-width: 744px;
  }

  .MuiDialog-paperWidthMd {
    max-width: 936px;
  }

  .MuiDialog-paperWidthLg {
    max-width: 1280px;
  }
`;

export const DialogInputTitle = styled.h4`
  font-size: ${({ theme }) => theme.fontSize.h4};
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  line-height: ${({ theme }) => theme.lineHeight.h4};
  text-align: left;
`;
